import { Accordion, AccordionActions, AccordionDetails, FormControl, AccordionSummary, Box, Button, Divider, FormControlLabel, InputAdornment, InputLabel, MenuItem, Select, Switch, TextField } from '@material-ui/core';
import { Add, CloseRounded, Delete, ExpandLess, ExpandMore, UnfoldMore } from '@material-ui/icons';
import { useEffect, useState } from 'react';

export const FormControls = ({ onUpdate, value, onDelete, isSelected }) => {
    const [label, setLabel] = useState("");
    const [fields, setFields] = useState([]);
    const [title, setTitle] = useState("");
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        try {
            let val = JSON.parse(value);
            setLabel(val.label);
            setTitle(val.title);
            setFields(val.fields);
        }
        catch {

        }
    }, [value]);

    useEffect(() => {
        setExpanded(isSelected);
    }, [isSelected])

    return (
        <div className='w-full'>
            <Accordion variant='outlined' expanded={expanded}>
                <AccordionSummary
                    className='handle'
                    expandIcon={
                        expanded ?
                            <ExpandLess onClick={() => setExpanded(!expanded)} /> :
                            <ExpandMore onClick={() => setExpanded(!expanded)} />
                    }
                    aria-label="Expand"
                    aria-controls="additional-actions1-content"
                    id="additional-actions1-header"
                    style={{ padding: "0 5px" }}
                >
                    <Box display="flex" alignItems="center" width={"100%"}>
                        <Box display="flex" alignItems="center">
                            <UnfoldMore htmlColor='#CECECE' />&nbsp;


                            <svg width="21" height="14" viewBox="0 0 21 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.5 5H19.5M1.5 9H19.5M10.5 5V13M3.5 13H17.5C18.6046 13 19.5 12.1046 19.5 11V3C19.5 1.89543 18.6046 1 17.5 1H3.5C2.39543 1 1.5 1.89543 1.5 3V11C1.5 12.1046 2.39543 13 3.5 13Z" stroke="#CECECE" stroke-width="1.26" />
                            </svg>

                        </Box>
                        <div className='pl-2 text-gray-500'>
                            Form
                        </div>
                    </Box>
                </AccordionSummary>
                <AccordionDetails>
                    <div className='w-full'>

                        <TextField
                            value={label}
                            margin='dense'
                            onChange={(e) => {
                                setLabel(e.target.value);
                                onUpdate(
                                    JSON.stringify(
                                        {
                                            label: e.target.value,
                                            title: title,
                                            fields: fields
                                        }
                                    )
                                );
                            }}
                            fullWidth
                            variant='outlined'
                            placeholder='Label'
                            label="Label"
                        />
                        <TextField
                            value={title}
                            margin='dense'
                            onChange={(e) => {
                                setTitle(e.target.value);
                                onUpdate(
                                    JSON.stringify(
                                        {
                                            label: label,
                                            title: e.target.value,
                                            fields: fields
                                        }
                                    )
                                );
                            }}
                            fullWidth
                            variant='outlined'
                            placeholder='Title'
                            label="Title"
                        />
                        <Divider className='my-2' />
                        {
                            fields.map((x, index) => {
                                return <div key={"jey" + index}>
                                    <FormControl variant="outlined" fullWidth>
                                        <InputLabel htmlFor="outlined-age-native-simple">Type</InputLabel>
                                        <Select
                                            value={fields[index] && fields[index].type}
                                            onChange={(e) => {
                                                let newFields = fields;
                                                fields[index].type = e.target.value;
                                                fields[index].name = e.target.value;
                                                setFields(newFields);
                                                onUpdate(
                                                    JSON.stringify(
                                                        {
                                                            label: label,
                                                            title: title,
                                                            fields: newFields
                                                        }
                                                    )
                                                );
                                            }}
                                            fullWidth
                                            native
                                            margin='dense'
                                            className='my-2'
                                            variant='outlined'
                                            placeholder={"Type"}
                                            label={"Type"}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="start">
                                                        {" "}
                                                        <CloseRounded onClick={() => {
                                                            setFields(fields.filter((z, i) => i !== index))
                                                        }} className="text-black-50" />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        >
                                            <option type="Short Text">Short Text</option>
                                            <option type="Long Text">Long Text</option>
                                            <option type="Email">Email</option>
                                            <option type="Website link">Website link</option>
                                            <option type="Phone Number">Phone number</option>
                                        </Select>
                                    </FormControl>
                                    <TextField
                                        value={fields[index] && fields[index].name}
                                        onChange={(e) => {
                                            let newFields = fields;
                                            fields[index].name = e.target.value;
                                            setFields(newFields);
                                            onUpdate(
                                                JSON.stringify(
                                                    {
                                                        label: label,
                                                        title: title,
                                                        fields: newFields
                                                    }
                                                )
                                            );
                                        }}
                                        fullWidth
                                        margin='dense'
                                        className='my-2'
                                        variant='outlined'
                                        placeholder={'Label'}
                                        label={'Label'}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="start">
                                                    {" "}
                                                    <CloseRounded onClick={() => {
                                                        setFields(fields.filter((z, i) => i !== index))
                                                    }} className="text-black-50" />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                    


                                    <TextField
                                        value={fields[index] && fields[index].placeholder}
                                        onChange={(e) => {
                                            let newFields = fields;
                                            fields[index].placeholder = e.target.value;
                                            setFields(newFields);
                                            onUpdate(
                                                JSON.stringify(
                                                    {
                                                        label: label,
                                                        title: title,
                                                        fields: newFields
                                                    }
                                                )
                                            );
                                        }}
                                        fullWidth
                                        margin='dense'
                                        className='my-2'
                                        variant='outlined'
                                        placeholder={'Placeholder'}
                                        label={'Placeholder'}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="start">
                                                    {" "}
                                                    <CloseRounded onClick={() => {
                                                        setFields(fields.filter((z, i) => i !== index))
                                                    }} className="text-black-50" />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                    <FormControlLabel
                                        control={<Switch checked={fields[index] && fields[index].checked}
                                            onChange={(e) => {
                                                let newFields = fields;
                                                fields[index].checked = e.target.checked;
                                                setFields(newFields);

                                                onUpdate(
                                                    JSON.stringify(
                                                        {
                                                            label: label,
                                                            title: title,
                                                            fields: newFields
                                                        }
                                                    )
                                                );
                                            }} />}
                                        label="Mark as required"
                                    />
                                    <Button
                                        variant='outlined'
                                        size='small'
                                        fullWidth
                                        onClick={() => {
                                            let newFields = fields.filter((x, cIndex) => cIndex !== index);
                                            setFields(newFields);
                                            onUpdate(
                                                JSON.stringify(
                                                    {
                                                        label: label,
                                                        title: title,
                                                        fields: newFields
                                                    }
                                                )
                                            );
                                        }}>
                                        Delete field
                                    </Button>
                                    <br />
                                    <br />
                                </div>

                            })
                        }
                        <Button
                            variant='outlined'
                            size='small'
                            startIcon={<Add />}
                            className='float-right'
                            onClick={() => setFields([...fields, {
                                name: "",
                                type: "",
                                placeholder: "",
                                checked: false
                            }])}>
                            Add field
                        </Button>
                    </div>
                </AccordionDetails>
                <AccordionActions>
                    <Button
                        className="ml-0"
                        startIcon={<Delete />}
                        onClick={() => {
                            setExpanded(false);
                            setLabel("");
                            setTitle("");
                            setFields([]);
                            onDelete();
                        }} fullWidth
                        variant='contained' color="default">
                        Remove
                    </Button>
                </AccordionActions>
            </Accordion>
        </div>
    )
}
